import axiosInstance from "../../../interceptor/intercetptor-inctence";

export const getSampleList = (formData) => {
    return axiosInstance.post(`api/master/sample-type/list`, formData);
}

export const statusSample = (id) => {
    return axiosInstance.post(`api/master/sample-type/change-status?sampleId=${id}`,{});
}

export const deleteSample = (id) => {
    return axiosInstance.post(`api/master/sample-type/delete?sampleId=${id}`,{});
}

export const addSample = (formData) => {
    return axiosInstance.post(`api/master/sample-type/add`,formData);
}

export const updateSample = (formData) => {
    return axiosInstance.post(`api/master/sample-type/update`,formData);
}

export const getGlobalSampleList = (formData) => {
    return axiosInstance.post(`api/global-master/sampleType_master`,formData);
}

export const addGlobalSample = (formData) => {
    return axiosInstance.post(`api/global-master/import_sampleType_master`,formData);
}
